
    import React from 'react';
    import { useUserActivityCreate, useUserActivitySoftDelete,useUserActivityMultipleSoftDelete, useUserActivityUpdate } from '../../queries/UserActivity.queries';
    import UserActivity from './UserActivity';
    
    const UserActivityContainer = () => {
    
      const {mutate:addRecord} = useUserActivityCreate();
      const {mutate:editRecord} = useUserActivityUpdate();
      const {mutate:deleteRecord} = useUserActivitySoftDelete();
      const {mutate:deleteRecords} = useUserActivityMultipleSoftDelete();
    
      const onAddRecord = (record) => {
        return new Promise((resolve,reject) => {
          addRecord(record, {
            onSuccess: async () => resolve('Record created successfully.'),
            onError: async (error) => reject(error?.message),
          });
        })
      };
    
      const onEditRecord = (record) => {
        return new Promise((resolve, reject) => {
          editRecord(
            record,
            {
              onSuccess: async () => resolve('Record updated successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
    
      const onDeleteRecord = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecord(
            record, 
            {
              onSuccess: async () => resolve('Record deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      const onMultiDelete = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecords(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      return (
        <UserActivity 
          addRecord={onAddRecord}
          deleteRecord={onDeleteRecord}
          deleteRecords={onMultiDelete}
          editRecord={onEditRecord}
        />
      )
    }
    
    export default UserActivityContainer;
    